import React from 'react';
import Search from './Search';
import api, { removeToken } from '../utils/api';
import Icon from './Icon';

const logout = () => {
  api.post('/auth/logout').then(() => {
    removeToken();
    window.location = '/';
  });
};

const Header = ({ search, user }) => (
  <>
    <div className="flex justify-center py-3 border-b border-gray-200 font-light">
      <div className="w-5/6 flex items-center justify-between">
        <a href="/" className="no-underline text-xl text-black">
          <img src={`${process.env.PUBLIC_URL}/logo-dieter.png`} alt="Logo Dieter Dewulf Photography" className="w-32" />
        </a>
        <div className="w-3/5 mx-3">
          <Search search={search} />
        </div>
        <button
          className="font-light flex flex-no-shrink items-center focus:outline-none"
          onClick={() => logout()}
        >
          <span>Welkom, {user && user.username}</span>
          <Icon name="chevron-right" className="w-5 h-5 pt-px" />
        </button>
      </div>
    </div>
    <div className="hidden sm:flex justify-center py-3 border-b border-gray-200 font-light">
      <div className="w-5/6 flex items-center justify-between">
        <p className="text-sm leading-none">
          Geen foto gevonden of loop je tegen een probleem aan? Neem contact op via <a href="tel:+32493556087">0493/55 60 87</a>.
        </p>
      </div>
    </div>
  </>
);

export default Header;
